import { trpc } from '@/lib/trpc';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Input } from '@/components/ui/input';
import { formatDateTime } from '@/lib/utils';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePagination } from '@/hooks/usePagination';

export function AllTicketsPage() {
  const { t } = useTranslation();
  // ✨ tRPC hook with full type safety
  const { data, isLoading, error } = trpc.tickets.getAllTickets.useQuery();

  const tickets = data?.data;
  // Paginado: son TODOS los tickets de la plataforma (el hook va antes de los returns tempranos)
  const { pageItems: pageTickets, footer: paginationFooter } = usePagination(tickets ?? [], 25);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">{t('tickets.admin.loading')}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-destructive">{t('errors.generic', { message: error.message })}</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-3xl font-bold tracking-tight">{t('tickets.admin.title')}</h2>
        <div className="relative w-64">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input placeholder={t('tickets.admin.search_placeholder')} className="pl-8" />
        </div>
      </div>
      <Card>
        <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('tickets.admin.table.id')}</TableHead>
              <TableHead>{t('tickets.admin.table.title')}</TableHead>
              <TableHead>{t('tickets.admin.table.requester')}</TableHead>
              <TableHead>{t('tickets.admin.table.status')}</TableHead>
              <TableHead>{t('tickets.admin.table.assigned')}</TableHead>
              <TableHead>{t('tickets.admin.table.date')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {pageTickets.map((ticket) => (
              <TableRow key={ticket.ticketId}>
                <TableCell className="font-mono text-xs">{ticket.ticketId.slice(0, 8)}</TableCell>
                <TableCell className="font-medium">{ticket.title}</TableCell>
                <TableCell>{ticket.createdByName}</TableCell>
                <TableCell>
                  <Badge>{ticket.status}</Badge>
                </TableCell>
                <TableCell>{ticket.assignedToName || t('tickets.admin.unassigned')}</TableCell>
                <TableCell>{formatDateTime(ticket.createdAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </div>
        {paginationFooter && <div className="px-4 pb-3">{paginationFooter}</div>}
      </Card>
    </div>
  );
}
